import { createRouter, createWebHistory } from "vue-router";
import store from '@/store.js';
import { timeNode } from "../utils";
import lotteryRouter from "@/views_lottery/helper/router";
import onlineInviteRoutes from '@/onlineInvite/helper/router' 
// const hotEvent = window.HotEvent;
const easyearn = window.easyearn;

const router = createRouter({
  history: createWebHistory(),
  routes: [
    // activityDetail 已下线
    // start
    {
      path: '/activityDetail',
      name: 'ActivityDetail',
      component: () => import('@/views/main.vue'),
      redirect: timeNode() === 1 ? '/reservePage' : '/activityDetail',
      children: [
        {
          path: '/activityDetail',
          name: 'ActivityDetailPage',
          component: () => import('@/views/activityDeatil.vue'),
          meta: { showHeader: false, title: ''},
        },
        {
          path: '/sharePage',
          name: 'SharePage',
          component: () => import('@/views/sharePage.vue'),
          meta: { showHeader: false, title: '国庆寻宝'},
        },
        {
          path: '/reservePage',
          name: 'ReservePage',
          component: () => import('@/views/reservePage.vue'),
          meta: { showHeader: false, title: ''},
        },
        {
          path: '/rulesPage',
          name: 'RulesPage',
          component: () => import('@/views/rulesPage.vue'),
          meta: { showHeader: true, title: '活动规则'},
        },
        {
          path: '/detailPage',
          name: 'DetailPage',
          component: () => import('@/views/detailPage.vue'),
          meta: { showHeader: true, title: '红包记录'},
        },
        {
          path: '/honor',
          name: 'Honor',
          component: () => import('@/views/honor.vue'),
          meta: { showHeader: false, title: '大千光荣榜'},
        },
        {
          path: '/exam',
          name: 'Exam',
          component: () => import('@/views/exam.vue'),
          meta: { showHeader: false, title: '考试平台'},
        },
      ],
    }, 
    // end
    {
      path: '/integral',
      name: 'Integral',
      component: () => import('@/views/main.vue'),
      redirect: '/integral/index',
      children: [
        {
          path: '/integral/index',
          name: 'integralIndex',
          component: () => import('@/views_integral/index.vue'),
          meta: { showHeader: false, title: '积分中心' },
        },
        {
          path: '/integral/rights',
          name: 'integralRights',
          component: () => import('@/views_integral/rights.vue'),
          meta: { showHeader: false, title: '权益详情' },
        },
        {
          path: '/integral/detail',
          name: 'integralDetail',
          component: () => import('@/views_integral/detail.vue'),
          meta: { showHeader: false, title: '等级明细' },
        },
        {
          path: '/integral/rules',
          name: 'integralRules',
          component: () => import('@/views_integral/rules.vue'),
          meta: { showHeader: true, title: '企鹅汇图等级体系规则' },
        }
      ],
    },
    {
      path: '/',
      name: 'Main',
      component: () => import('@/views_v3.15.0/main.vue'),
      redirect: '/examination',
      children: [
        {
          path: '/examination',
          name: 'Examination',
          component: () => import('@/views_v3.15.0/examination.vue'),
        },
        {
          path: '/examreslut',
          name: 'Examreslut',
          component: () => import('@/views_v3.15.0/examreslut.vue'),
        },
        {
          path: '/examHelpPage',
          name: 'ExamHelpPage',
          component: () => import('@/views_v3.15.0/examHelpPage.vue'),
        }
      ],
    },
    {
      path: '/message',
      name: 'message',
      component: () => import('@/view_message_appear/main.vue'),
      redirect: '/message_appear_type',
      children: [
        {
          path: '/message_appear_type',
          name: 'messageAppearType',
          component: () => import('@/view_message_appear/messageAppearType.vue'),
        },
        // 小程序
        {
          path: '/message_appear_detail',
          name: 'messageAppearDetail',
          component: () => import('@/view_message_appear/messageAppearDetail.vue'),
        },
        // 客户端h5
        {
          path: '/message_appear_detail_h5',
          name: 'messageAppearDetailH5',
          component: () => import('@/view_message_appear/messageAppearDetailH5.vue'),
        },
        {
          path: '/message_appear_history',
          name: 'messageAppearHistory',
          component: () => import('@/view_message_appear/messageAppearHistory.vue'),
        },
        {
          path: '/add_location_type',
          name: 'addLocationType',
          component: () => import('@/view_message_appear/poiComponent/locationType.vue'),
        },
        {
          path: '/add_location_detail',
          name: 'addLocationDetail',
          component: () => import('@/view_message_appear/poiComponent/locationDetail.vue'),
        },
        {
          path: '/staff_report',
          name: 'staffReport',
          component: () => import('@/view_message_appear/poiComponent/staffLocationDetail.vue'),
        },
        {
          path: '/report_success',
          name: 'reportSuccess',
          component: () => import('@/view_message_appear/submitSucess.vue'),
        },
        // 给小程序使用的-交警上报
        {
          path: '/police_report',
          name: 'policeReport',
          component: () => import('@/view_message_appear/policeReportPage.vue'),
        },
        // 语音上报-上报单确认
        {
          path: '/voice_report_confirm',
          name: 'voiceReportConfirm',
          component: () => import('@/view_message_appear/voiceReportConfirm.vue'),
        },
        // 语音上报-上报历史
        {
          path: '/voice_report_history',
          name: 'voiceReportHistory',
          component: () => import('@/view_message_appear/voiceReportHistory.vue'),
        },
      ],
    },
    {
      ...lotteryRouter
    },
    {
      ...onlineInviteRoutes,
    }
  ]
});
// const getUserInfo = () => {
//   return new Promise(resolve => {
//     if (hotEvent && !store.getters.userInfo) {
//       const userInfo = hotEvent.getInfo();
//       store.dispatch('setUserInfo', userInfo);
//       resolve();
//     } else {
//       if (window.location.host === 'localhost:8080') {
//         store.dispatch('setUserInfo', 'oA9LiwHNqZFMS5IztKOQfMmd1y5M/0');
//       }
//       resolve();
//     }
//   })
// }

const getUserInfo = () => {
  console.log(store.getters.userInfo, easyearn, store.getters.accessToken, store.getters.refreshToken, 'router');
  // 有改动
  if(window.location.pathname.includes('examination') || 
  window.location.pathname.includes('message')){
    if(easyearn && store.getters.accessToken){
      return
    }
  }else{
    if(easyearn && store.getters.userInfo){
      return
    }
  }
  // console.log(easyearn.getAccessToken(), easyearn.getRefreshToken(), 888);
  return new Promise(resolve => {

    var UA = navigator.userAgent.toLowerCase();
    if (UA.indexOf("Chrome") > 0 && window.location.pathname.includes('examination')) {
      var index = UA.split("Chrome/")[1].substring(0, 2);
      if (index <= 60) {
        // alert("您的安卓版本过低，暂不支持查看用户等级，请升级后使用！");
        alert("您的手机版本较低，正在为您跳转至网页进行考试");
        // window.easyearn.goBack();
        // return;
      }
    }
    if (easyearn && !store.getters.accessToken && Object.prototype.hasOwnProperty.call(easyearn, 'getAccessToken')) {
      const accessToken = easyearn.getAccessToken();
      const refreshToken = easyearn.getRefreshToken();
      store.dispatch('setAccessToken', accessToken);
      store.dispatch('setRefreshToken', refreshToken);
    }
    // 版本号 >= 32102007 不传openId  为false
    // isHaveOpenId  true 为 传
    if (easyearn && !store.getters.versioncode && Object.prototype.hasOwnProperty.call(easyearn, 'getVersionCode')) {
      const versioncode = easyearn.getVersionCode();
      const isHaveOpenId = Number(versioncode) >= Number(32102007)
      ? false : true;
      console.log(versioncode, 'versioncode');
      store.dispatch('setVersioncode', versioncode);
      store.dispatch('setHaveOpenId', isHaveOpenId);
    }
    // 是否已经通过 easyearn 桥拿到 userInfo。用于决定是否继续进入 H5 兜底分支。
    // 原实现用 if/else if/else 级联，这里拆成"先尝试桥、再按未命中走兜底"两段，
    // 语义等价但对 Android WebView 的 JS Bridge 原型链注入更健壮。
    let easyearnUserInfoResolved = false;
    if (easyearn && !store.getters.userInfo) {
      // APP 版本差异：
      //   - 新版 easyearn 暴露 getOpenId()
      //   - 旧版 easyearn 暴露 getInfo()
      //   - 个别中间过渡版本两者都没有（语音上报等纯 H5 页面可直接走 H5 兜底）
      //
      // 注意不能用 Object.prototype.hasOwnProperty 判断 —— Android WebView 的 JS Bridge
      // 注入对象方法经常挂在原型链上而不是 own property，hasOwnProperty('getOpenId')
      // 会返回 false，但 easyearn.getOpenId() 其实是可调用的；此时原来的 else if 分支
      // 会去调 easyearn.getInfo()，在不存在该方法的版本上抛出
      // "TypeError: u.getInfo is not a function"，阻塞整个路由守卫（见 voice_report_confirm
      // 等 H5 页面首次加载报错）。
      //
      // 修复：一律改为"先尝试 getOpenId，失败再尝试 getInfo，都失败则静默降级"，
      // 并用 typeof fn === 'function' 代替 hasOwnProperty，兼容原型链注入。
      let userInfo = null;
      try {
        if (typeof easyearn.getOpenId === 'function') {
          userInfo = easyearn.getOpenId();
        }
      } catch (e) {
        console.warn('[router] easyearn.getOpenId 调用异常，尝试 getInfo 兜底:', e && e.message);
      }
      if (!userInfo) {
        try {
          if (typeof easyearn.getInfo === 'function') {
            userInfo = easyearn.getInfo();
          }
        } catch (e) {
          console.warn('[router] easyearn.getInfo 调用异常:', e && e.message);
        }
      }
      if (userInfo) {
        store.dispatch('setUserInfo', userInfo);
        easyearnUserInfoResolved = true;
      }
      // userInfo 还是空 → 继续走下面的 H5 兜底分支（与原实现一致，不阻塞路由）
    }
    // 等价于原 else 分支：只有 easyearn 存在且本轮刚成功拿到 userInfo 时才跳过兜底；
    // 其余情况（无 easyearn / easyearn 存在但本轮桥未命中 / 已有 userInfo 等）均进入兜底。
    if (!(easyearn && easyearnUserInfoResolved)) {
      if (
        window.location.href.includes('previewBtn')
        || window.location.href.includes('examination')
        || window.location.pathname.includes('onlineinvite')
        || window.location.pathname.includes('message')
        || window.location.pathname.includes('lottery')
        || window.location.pathname.includes('location')
        || window.location.pathname.includes('staff_rep')
        || window.location.pathname.includes('report_success')
        || window.location.pathname.includes('police_report')
        || window.location.pathname.includes('voice_report_confirm')
        || window.location.pathname.includes('voice_report_history')
      ) {
        // store.dispatch('setUserInfo', 'oA9LiwCfXRDKN1GDkwSIK7HFnmnc');
        // store.dispatch('setUserInfo', 'oA9LiwOVHRl63Ax_H19o7jQ0O8Xo');
        // store.dispatch('setUserInfo', 'oA9LiwKQobL62mcxErCTE7Eb4N7U');
        if (store.state.isH5) {
          store.dispatch('setHaveOpenId', false);
        }
        store.dispatch('setHaveOpenId', false);
        // store.dispatch('setHaveOpenId', true);
        store.dispatch('setVersioncode', 32102007);
        if(!store.state.isH5) {
          store.dispatch('setAccessToken', 'b0d454fd29df4d258af81bf5a30c6d3a');
          store.dispatch('setRefreshToken', 'b79df1d23e9f4a14aeba234fe99ecbd6');
        }
        // store.dispatch('setUserInfo', 'oA9LiwJPoAah6MWl-zPOSLChE8c4');
        // store.dispatch('setUserInfo', 'oA9LiwFy66JcrTkKiQAZjAE4C6iE');
      }
      // resolve();
    }
    resolve();
  })
}

router.beforeEach(async () => {
  await getUserInfo();
});

export default router;
